(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.controller('SingleStoreCtrl', ['$scope', '$state', 'storeId', 'store', '$uibModal', '$timeout', '$rootScope', '$Stores', '$localForage', '$http', '$templateCache', '$compile', function($scope, $state, storeId, store, $uibModal, $timeout, $rootScope, $Stores, $localForage, $http, $templateCache, $compile) {


        angular.extend($scope, {

            // vars

            loading: true,

            alerts: [
                // { type: 'danger', msg: 'Oh snap! Change a few things up and try submitting again. adfs' },
                // { type: 'success', msg: 'Well done! You successfully read this important alert message.' }
            ],

            design_review_incomplete: true,
            captured_name_and_email: false,
            submited_review: false,
            reviewer_name: null,
            reviewer_email: null,

            store: store,

            //methods

            testing: function() {
                console.log('store', store);
            },

            IsDesignReviewIncomplete: function(){

                return _.any(store.products, function(prod) {
                    if(!prod.design_status || prod.design_status === 'unapproved'){
                        return true;
                    }
                })

            },

            submitReview: function() {
                $scope.store.last_design_review = moment().format();
                $scope.store.last_design_review_email = $scope.reviewer_email;
                $scope.store.last_design_review_name = $scope.reviewer_name;
                $scope.submited_review = true;
                $scope.store.review_locked = "locked";
                $scope.store.$save().then(function(){

                    var scope = angular.extend($scope.$new(), {
                        products: $scope.store.products,
                        reviewer:{
                            email: $scope.reviewer_email,
                            name: $scope.reviewer_name
                        }
                    });

                    let template = $templateCache.get('directives/externalStore/customerDesignReviewEmailTemplate.html');

                    // console.log('template -> ', template);

                    let el = $compile(template)(scope);

                    console.log('message html ->', el.html());

                    $timeout(function() {

                      var queryString = $.param({
                        emailTo: $scope.reviewer_email,
                        emailFrom: 'Breakmark Team Store <teamstore@breakmark.com>',
                        subject: store.name + ' Design Review',
                        message: el.html()
                      })

                        $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/emailServer?'+queryString).then( (response) => {

                            console.log('send email -> email success', response);

                        }, (errorResponse) => {

                            console.log('send email -> errorResponse', errorResponse);

                            alert('There was an issue in trying to send you a copy of your design review.');

                        });

                    }, 2000);

                });



            },

            init: function() {

                // TODO: Check local storage for a stored store (read: incomplete purchase)

                $localForage.getItem('myCart-' + storeId).then(function(data) {
                    if(data){
                        $rootScope.cart = data;
                    } else {
                        $rootScope.cart = {};
                    }
                    $scope.updateCartTotal();
                });

                $scope.watchers();

                $timeout(function() {

                    $scope.store = store;

                    $scope.loading = false;

                }, 1200);

            },

            closeAlert: function(index) {

              $scope.alerts.splice(index, 1);

            },

            addProduct: (product) => {

                if(product.properties){
                    $scope.lightboxProduct(product);
                } else {
                    // product has no properties
                    $scope.lightboxProduct(product);
                    // $scope.addDirectlyToCart(product);
                }

            },

            lightboxProduct: function(product) {

                $uibModal.open({
                    animation: true,
                    templateUrl: 'directives/externalStore/singleProductModal.html',
                    windowClass: 'single-product-modal',
                    controller: 'LightboxProductModal',
                    resolve: {
                        product: function() {
                            return product;
                        },
                        store: function() {
                            return store
                        }
                    },
                    size: 'lg'
                });

            },

            showProductDesignApprovalModal: function(product) {

                if(product.design_status === 'approved') return;

                let reviewModal = $uibModal.open({
                    animation: true,
                    windowClass: 'review-design-modal',
                    templateUrl: 'directives/externalStore/modals/product_design_review_modal.html',
                    controller: 'ProductDesignReviewModalController',
                    resolve: {
                        product: function() {
                            return product;
                        },
                        store: function() {
                            return store
                        }
                    },
                    size: 'lg'
                });

                reviewModal.result.then(function(itemStatus){

                    product.reviewer_email = $scope.reviewer_email;
                    product.reviewer_name = $scope.reviewer_name;

                    if(itemStatus.status === 'rejected'){

                        product.design_status = 'rejected';
                        product.design_status_change_date = moment().format();
                        product.rejection_message = itemStatus.rejection_message;

                    }

                    if(itemStatus.status === 'approved'){

                        product.design_status = 'approved';
                        product.design_status_change_date = moment().format();
                        product.rejection_message = null;

                    }

                    if(itemStatus.status === 'reset'){

                        product.design_status = null;
                        product.design_status_change_date = null;

                    }

                    if(!$scope.IsDesignReviewIncomplete()){

                        $scope.design_review_incomplete = false;

                    }

                });

            },

            capturedNameAndEmail: function(form) {
                $scope.captured_name_and_email = true;
                $scope.reviewer_email = form.reviewer_email.$modelValue;
                $scope.reviewer_name = form.reviewer_name.$modelValue;
            },

            openPackageWizard: function(thePackage) {

                $uibModal.open({
                    animation: true,
                    templateUrl: 'directives/externalStore/packageWizardModal.html',
                    controller: 'PackageWizardModal',
                    windowClass: 'package-wizard-modal',
                    resolve: {
                        thePackage: function() {
                            return thePackage;
                        },
                        store: function() {
                            return store;
                        }
                    },
                    size: 'lg'
                });

            },

            addDirectlyToCart: function(product) {

                let propertyFormedCartProduct = {
                    name: product.name,
                    price: product.basePrice,
                    quantity: 1,
                    thumbnail: product.productImage
                };

                $rootScope.$emit('cart.product.added', propertyFormedCartProduct);

            },

            saveCart: function() {

                $localForage.setItem('myCart-' + storeId, $rootScope.cart).then(function(data) {
                    // console.log('cart saved', data);
                });

                $scope.updateCartTotal();

            },

            updateCartTotal: function() {

                let cartTotal = 0;

                if($rootScope.cart.products){
                    // console.log('i have products');
                    _.forEach($rootScope.cart.products, (product) => {
                        cartTotal += parseFloat(product.price);
                    });
                }

                if($rootScope.cart.packages){
                    // console.log('i have packages');
                    _.forEach($rootScope.cart.packages, (thePackage) => {
                        cartTotal += parseFloat(thePackage.calculatedPackageCost);
                    });
                }

                $rootScope.cart.total = parseFloat(cartTotal);
            },

            watchers: function() {

                $rootScope.$on('cart.product.added', function(event, item) {

                    if($rootScope.cart.products){
                        $rootScope.cart.products.push(item);
                    } else {
                        $rootScope.cart.products = [item];
                    }
                    $scope.saveCart();

                    $scope.updateCartTotal();

                    $scope.alerts.push({
                        type: 'success',
                        msg: 'Added ' + item.name + ' to cart.'
                    });

                    $timeout(function() {

                        $scope.alerts.length = 0;

                    }, 2500);

                });

                $rootScope.$on('cart.package.added', function(event, item) {

                    $scope.saveCart();

                    $scope.updateCartTotal();

                    $scope.alerts.push({
                        type: 'success',
                        msg: 'Added ' + item.name + ' to cart.'
                    });

                    $timeout(function() {

                        $scope.alerts.length = 0;

                    }, 2500);

                });

                $rootScope.$on('cart.package.removed', function(event) {

                    $scope.saveCart();

                });

                $rootScope.$on('cart.product.removed', function(event) {

                    $scope.saveCart();

                });

                $rootScope.$on('cart.products.removed', function(event) {

                    $scope.saveCart();

                });

            }

        });

        $scope.init();

    }]);

})();
